// src/features/lookup/page/PlanGroup

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { CurrencyType } from '../../types/lookupTypes';
import { useTranslation } from 'react-i18next';



const CurrencyPage = () => {
    const { t } = useTranslation();

    // Define columns for the PlanGroup table
    const CurrencyColumns: ColumnsType<CurrencyType> = [
        { title: "ISOCode", dataIndex: "isoCode", key: "isoCode", sorter: true },
        { title: "Name", dataIndex: "name", key: "name", sorter: true },
        { title: "Symbol", dataIndex: "symbol", key: "symbol" }

    ];

    return (
        <div>
            
            <DynamicTable<CurrencyType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.LOOKUP.GET_CURRENCY} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.LOOKUP.CURRENCY} // Unique query key for menus
                columns={CurrencyColumns}
                showActions={false} // Set to true if you want Edit/Delete actions
                tableTitle={t("Currency")}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "Search by Name" },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.LOOKUP.EXPORT_CURRENCY,
                            fileName: "Currencies",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "ISOCode", key: "isoCode" },
                                { header: "Name", key: "name" },
                                { header: "Symbol", key: "symbol" },
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default CurrencyPage;